import { CONST } from '@/utils/constants'
import { URLS } from '@/utils/urls'

import router from '@/router'

export const resolve = (path = '', caseSensitive = false) => {
  // Normalize
  let uri = (caseSensitive) ? (path || '') : (path || '').toLowerCase()
  let gwt = (caseSensitive) ? CONST.Services.Paths.GWT : CONST.Services.Paths.GWT.toLowerCase()
  let vue = (caseSensitive) ? CONST.Services.Paths.Vue : CONST.Services.Paths.Vue.toLowerCase()
  let net = (caseSensitive) ? CONST.Services.Paths.App : CONST.Services.Paths.App.toLowerCase()
  // GWT (absolute path)
  if (uri.startsWith(gwt)) return { type: 'gwt', url: `${CONST.Services.Hosts.GWT}${path}` }
  // Vue (relative path)
  if (uri.startsWith(vue)) return { type: 'vue', url: `${path.substring(vue.length)}` }
  // Net (absolute path) -- C# Razor template paths
  if (uri.startsWith(net)) return { type: 'net', url: `${path}` }
  // Other (unrecognised path)
  return { type: null, url: path }
}
export const refresh = () => router.go()
export const redirect = (url) => window.location.assign(url)
export const redirectOrRefresh = (url) => url ? window.location.assign(`${CONST.Services.Hosts.App}${url}`) :  refresh()
export const push = (route) => router.push(route)
export const replace = (route) => router.replace(route)
export const go = (url) => {
  // Resolve url
  const destination = resolve(url)
  // Switch depending on Addresses Router Type
  switch (destination.type) {
    case null:
      // Unrecognized: Fallback to App Home
      push(URLS.App.Home())
      break
    case 'gwt':
      redirect(destination.url)
      break
    case 'vue':
      push(destination.url)
      break
    case 'net':
      redirect(`${CONST.Services.Hosts.App}${destination.url}`)
      break
  }
}

export const navigation = {
  resolve,
  refresh,
  redirect,
  redirectOrRefresh,
  push,
  replace,
  go
}

export default navigation
